import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  fetchShippingRestrictionDetail,
  getShippingRestrictionDetail,
  getShippingRestrictionDetailStatus,
} from '../../deliveryMethodsSlice';
import {
  ShippingRestrictionFormValues,
  dtoToFormValues,
} from '../../pages/ShippingRestrictionPages/types';

function useGetShippingRestrictionDetail() {
  const dispatch = useAppDispatch();
  const restrictionDto = useSelector(getShippingRestrictionDetail);
  const { isLoading, isError, isSuccess } = useSelector(
    getShippingRestrictionDetailStatus,
  );

  const restriction: ShippingRestrictionFormValues | undefined = useMemo(() => {
    if (!restrictionDto) return undefined;
    return dtoToFormValues(restrictionDto);
  }, [restrictionDto]);

  const fetchDetail = useCallback(
    (id: string) => {
      dispatch(fetchShippingRestrictionDetail(id));
    },
    [dispatch],
  );

  return {
    restriction,
    isLoading,
    isError,
    isSuccess,
    fetchDetail,
  };
}

export default useGetShippingRestrictionDetail;
